var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPageArrow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 14,
    viewBox: "0 0 8 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.234315 0.227806C0.546734 -0.0759353 1.05327 -0.0759353 1.36569 0.227806L7.76569 6.45003C8.0781 6.75377 8.0781 7.24623 7.76569 7.54997L1.36569 13.7722C1.05327 14.0759 0.546734 14.0759 0.234315 13.7722C-0.0781049 13.4685 -0.0781049 12.976 0.234315 12.6723L6.06863 7L0.234315 1.32775C-0.0781049 1.02401 -0.0781049 0.531547 0.234315 0.227806Z",
    fill: "#91979E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPageArrow);
export default __webpack_public_path__ + "static/media/pageArrow.65e23ad053f91d2bf069c815f052349d.svg";
export { ForwardRef as ReactComponent };